import React, { useEffect, useRef, useState } from "react";

const STEPS = [
  { shot: "05-setup-add-documents", title: "Add your documents", sub: "Drinks menu, supplier invoices and a sales report.", alt: "Add your drinks menu, invoices and sales report to set up Barlo" },
  { shot: "06-setup-check-list", title: "Check your product list", sub: "Prices, costs, case sizes and par levels, built for you.", alt: "Product list built from your documents, ready to check" },
  { shot: "02-stock-count", title: "Film and count", sub: "Film the shelf and talk. Barlo counts it, you confirm.", alt: "Stocktake by filming the shelf" },
  { shot: "04-orders", title: "Send the weekly order", sub: "Built from your par levels. One button emails every supplier.", alt: "Weekly supplier order built from par levels" },
  { shot: "07-barlo-ai", title: "Ask Barlo AI", sub: "Ask about your stock, sales and orders. On Pro it does the job, you confirm.", alt: "Barlo AI answering a question about the venue" },
];
const DUR = 4000;

export default function StepsDemo() {
  const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const [step, setStep] = useState(0);
  const [paused, setPaused] = useState(reduce);
  const [progress, setProgress] = useState(0);
  const done = useRef(0); // share of the current step already shown (0 to 1)

  // A new step always starts from zero; play/pause carries on where it stopped.
  useEffect(() => { done.current = 0; setProgress(0); }, [step]);

  useEffect(() => {
    if (paused) return undefined;
    let id;
    const start = performance.now() - done.current * DUR;
    const tick = (now) => {
      const p = (now - start) / DUR;
      done.current = Math.min(p, 1);
      if (p >= 1) { setStep((s) => (s + 1) % STEPS.length); return; }
      setProgress(p);
      id = requestAnimationFrame(tick);
    };
    id = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(id);
  }, [paused, step]);

  return (
    <section className="demo" id="how-it-works" style={{ borderTop: 0, paddingTop: 0 }}>
      <div className="wrap demo-grid">
        <div className="demo-copy">
          <span className="label">How it works</span>
          <h2 style={{ marginTop: 14 }}>From paperwork to order, in five steps<span className="dot">.</span></h2>
          <ol className="steps">
            {STEPS.map((s, i) => (
              <li key={s.title}>
                <button type="button" aria-current={i === step ? "step" : undefined} onClick={() => setStep(i)}>
                  <span className="n">{i + 1}</span>
                  <span><b>{s.title}</b><span className="s">{s.sub}</span></span>
                </button>
              </li>
            ))}
          </ol>
          <button type="button" className="btn btn-ghost demo-pause" aria-pressed={paused} onClick={() => setPaused((p) => !p)}>
            {paused ? "Play" : "Pause"}
          </button>
        </div>
        <div className="demo-media">
          <div className="phone demo-phone">
            <div className="screen">
              {STEPS.map((s, i) => (
                <div key={s.shot} className={`shot ${i === step ? "is-on" : ""}`}>
                  <img className="light-only" src={`/img/light-${s.shot}.webp`} alt={i === step ? s.alt : ""} width="540" height="1169" loading="lazy" />
                  <img className="dark-only" src={`/img/dark-${s.shot}.webp`} alt="" width="540" height="1169" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
          <div className="demo-bar" aria-hidden="true"><span style={{ width: `${progress * 100}%` }} /></div>
        </div>
      </div>
    </section>
  );
}
